<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

// Components
import Button from '@/Components/Button/Button.vue';
import AddOnLabel from '@/Components/AddOnLabel.vue';
import MenuCardMenu from './MenuCardMenu.vue';

const props = defineProps({
    title: String,
    pdfs: Array,
    menus: Array,
    addOnLabel: Boolean,
});

const moduleActive = computed(() => usePage().props.template_options.modules.menu_active);
</script>

<template>
    <div class="container py-12 md:py-16" :class="{ ' relative  ': addOnLabel }" v-if="moduleActive">
        <AddOnLabel v-if="addOnLabel" />

        <div class="flex justify-center">
            <h2 class="mb-3 " v-html="title" v-if="title"></h2>
        </div>

        <div class="flex flex-col justify-center md:gap-4 md:flex-row" v-if="pdfs.length">
            <Button
                v-for="(item, i) in pdfs"
                :is="'a'"
                :href="'/storage/' + item.file"
                :label="item.name"
                target="_blank"
                class="relative z-30 w-auto mt-8"
                :key="i"
            ></Button>
        </div>

        <MenuCardMenu v-for="menu in menus" :key="menu.id" :menu="menu" />
    </div>
</template>
